<template>
  <div class="page">
    <mobileHeader :title="`批量扫码`" rightType="scanCode" @scanCode="scanCode"></mobileHeader>
    <div class="bottle-list">
      <template v-if="bottleList.length">
        <div class="bottle-item" v-for="(it, i) in bottleList" :key="i">
          <img src="@/assets/images/Scan_code_icon_bottle.png" alt="">
          <div class="w_100">
            <div class="d_f">
              <div class="flex_1">气瓶二维码</div>
              <div class="bottle-code" @click="showBottleUserInfo(it)">{{it.bottle_id}}</div>
            </div>
            <div class="d_f">
              <div class="flex_1">出产编号</div>
              <div class="bottle-code">{{it.can_release_no}}</div>
            </div>
            <van-icon name="cross" @click="closeBottle(it)"/>
          </div>
        </div>
      </template>
      <div v-else class="no-scan">请先点击右上角扫码</div>
      <div class="bottle-filling">
        <div class="bottle-filling-header">
          <img src="@/assets/images/Scan_code_icon_bottle2.png" alt="">
          <div>充装</div>
        </div>
        <div class="bottle-step-list">
          <div class="bottle-step-item" :class="type == '空瓶进站' && 'bottle-step-item-act'" @click="type = '空瓶进站'">空瓶进站</div>
          <div class="bottle-step-item" :class="type == '重瓶发出' && 'bottle-step-item-act'" @click="type = '重瓶发出'">重瓶发出</div>
          <div class="bottle-step-item" :class="type == '重瓶退回' && 'bottle-step-item-act'" @click="type = '重瓶退回'">重瓶退回</div>
          <div class="bottle-step-item" :class="type == '重瓶入库' && 'bottle-step-item-act'" @click="type = '重瓶入库'">重瓶入库</div>
        </div>
        <carCodeBox :car_number="car_number" @setCarCode="(code) => car_number = code" />
        <div class="bottle-button">
          <div @click="submit">提交</div>
        </div>
      </div>
      <van-popup v-model="bottleUserInfoShow" position="center">
        <div class="bottle-user-info">
          <div class="bottle-user-info-name">用户名称：{{bottleUserInfo.name || "暂无"}}</div>
          <div class="bottle-user-info-phone">用户手机：{{bottleUserInfo.phone || "暂无"}}</div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import mobileHeader from "@/components/mobileHeader";
import { Toast, Dialog } from "vant";
import carCodeBox from "./components/carCodeBox.vue"
import { batchFillings, getBottleInfo } from "@/api/flowPath";
export default {
  components: {mobileHeader, carCodeBox},
  data(){
    return {
      bottleList: [
        {bottle_id: "4444", can_release_no: "222"}
      ],
      type: '空瓶进站',
      car_number: "",
      address: "",
      bottleUserInfoShow: false,
      bottleUserInfo: {
        name: "",
        phone: ""
      },
    }
  },
  created(){
    this.getLocation();
  },
  methods: {
    getLocation() {
      this.mixGetLocation((location) => {
        this.address = location.address;
      });
    },
    async scanCode(bottle_id){
      const index = this.bottleList.indexOf(bottle_id)
      if(index != -1)return Toast("该二维码已填写")
      const {code, msg, data} = await getBottleInfo({bottle_id}, 1)
      if(code != 200)return Toast(msg)
      this.bottleList.push({bottle_id, ...data})
    },
    // 把码添加进缓存
    async setCarCodeCache(number){
      console.log("开始执行了")
      let carCodeList = this.carCodeList
      const findIndex = carCodeList.findIndex(it => it == number)
      if(findIndex != -1){
        carCodeList.splice(findIndex, 1)
      }
      carCodeList.unshift(number)
      this.carCodeList = carCodeList
      this.mixSetCache("carCodeList", carCodeList)
    },
    openScan(){
      JS.takePhote()
      console.log("打开相机")
    },
    closeBottle(code){
      const index = this.bottleList.indexOf(code)
      Dialog.confirm({
        title: "提示",
        message: "您确定删除吗",
        beforeClose: (action, done) => {
          if (action === "confirm") {
            this.bottleList.splice(index, 1)
          }
          done(true)
        },
      });
    },
    async submit(){
      if(this.bottleList.length == 0)return Toast("请先点击右上角扫码")
      const step_name = this.type
      const car_number = this.car_number
      console.log(this.car_number,"this.car_number")
      const station_check_location = this.address
      console.log(this.bottleList.map(({bottle_id}) => ({step_name, car_number, station_check_location, bottle_id})))
      const {code, msg} = await batchFillings({data: this.bottleList.map(({bottle_id}) => ({step_name, car_number, station_check_location, bottle_id}))})
      if(code != 200)return Toast(msg)
      Toast("添加完成")
      this.bottleList = []
      this.type = '空瓶进站'
      this.car_number = ""
    },
    showBottleUserInfo({last_use_name, last_use_phone}){
      this.bottleUserInfo.name = last_use_name
      this.bottleUserInfo.phone = last_use_phone
      this.bottleUserInfoShow = true
    }
  }

}
</script>

<style lang="scss" scoped>
::v-deep .header-title{
  font-size: 5vw;
}
.page{
  min-height: 100vh;
  background: #f3f3f3;
  .bottle-list{
    background: #f3f3f3;
    padding: 3.3vw 2.7vw;
    .bottle-item{
      background: white;
      display: flex;
      line-height: 18vw;
      align-items: center;
      padding: 1vw 2.8vw;
      border-radius: 1.3vw;
      position: relative;
      & > img{
        width: 12vw;
        height: 12vw;
        margin-right: 2.5vw;
      }
      .bottle-code{
        display: flex;
        align-items: center;
        margin-right: 6vw;
      }
      .van-icon-cross{
        width: 4vw;
        height: 4vw;
        background: #FF0000;
        border-radius: 50%;
        color: white;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 4vw;
        position: absolute;
        right: 2vw;
        top: calc(50% - 2vw);
      }
    }
    .bottle-item + .bottle-item{
      margin-top: 4vw;
    }
    .bottle-filling{
      margin-top: 4.3vw;
      border-radius: 1.5vw;
      overflow: hidden;
    }
    .bottle-filling-header{
      line-height: 18vw;
      background: white;
      display: flex;
      padding: 0 2.8vw;
      align-items: center;
      & > img{
        width: 12vw;
        height: 12vw;
        margin-right: 2.5vw;
      }
    }
    .bottle-step-list{
      background: white;
      padding: 0 2.8vw;
      .bottle-step-item{
        color: #00A2FF;
        width: 100%;
        line-height: 13vw;
        border: 1px solid #00A2FF;
        text-align: center;
        border-radius: 1vw;
        transition: all 0.3s;
      }
      .bottle-step-item + .bottle-step-item{
        margin-top: 20px;
        
      }
      .bottle-step-item-act{
        background: #00a2ff;
        color: white;
      }
    }
    .no-scan{
      text-align: center;
      background: white;
      line-height: 16vw;
      color: #5c5c5c;
      border-radius: 1.5vw;
    }
    .bottle-button{
      width: 100%;
      padding: 0 2.8vw;
      background: white;
      box-sizing: border-box;
      padding-bottom: 5vw;
      div{
        line-height: 13vw;
        background: #00a2ff;
        border-radius: 1vw;
        text-align: center;
        color: white;
      }
      div:active{
        opacity: 0.8;
      }
    }
  }
}

  ::v-deep .van-popup{
    border-radius: 6px;
    overflow: hidden;
  }
  .bottle-user-info{
    min-width: 70vw;
    line-height: 40px;
    padding: 10px 20px;
  }
  .d_f{
    display: flex;
    line-height: 7vw;
    font-size: 4vw
  }
  .w_100{
    width: 100%
  }
  .flex_1{
    flex: 1
  }
</style>